import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createDistributionSetup({ commit }, data) {
      try {
        return await api.post(`/params/distributions`, data)
      } catch (error) {
        throw error
      }
    },

    async getDistributionsSetup({ commit }) {
      try {
        const response = await api.get(`/params/distributions`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getDistributionSetup({ commit }, id) {
      try {
        const response = await api.get(`/params/distributions/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateDistributionSetup({ commit }, data) {
      try {
        return await api.put(
          `/params/distributions/${data.id}`,
          data.distributionSetup,
        )
      } catch (error) {
        throw error
      }
    },

    async runDistributionsSetup({ commit }, id) {
      try {
        return await api.post(`/params/distributions/${id}/run`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
